import { render, staticRenderFns } from "./TbFilaAtendimento.vue?vue&type=template&id=cbd6d0b2&scoped=true"
import script from "./TbFilaAtendimento.vue?vue&type=script&lang=js"
export * from "./TbFilaAtendimento.vue?vue&type=script&lang=js"
import style0 from "./TbFilaAtendimento.vue?vue&type=style&index=0&id=cbd6d0b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd6d0b2",
  null
  
)

export default component.exports